import React, { useRef, useEffect, useCallback } from "react";

const ServiceBackground = () => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);

  // 비디오 설정 및 재생 보장
  const setupVideo = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;

    // 더 적극적인 비디오 로딩 설정
    video.preload = 'auto'; // metadata에서 auto로 다시 변경
    video.playsInline = true;
    video.muted = true;
    
    // 비디오 속성 강제 설정
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    
    // 하드웨어 가속 활용
    video.style.willChange = 'transform';

    console.log('🎬 ServiceBackground 비디오 설정 완료');
  }, []);

  // 비디오 재생 강제 실행
  const forcePlayVideo = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;

    console.log('🎬 ServiceBackground 비디오 재생 강제 시도');
    
    if (video.paused) {
      video.currentTime = 0;
      video.play().catch(e => {
        console.log('ServiceBackground 재생 실패:', e.message);
        // 사용자 인터랙션 대기
        const playOnInteraction = () => {
          video.play();
          document.removeEventListener('click', playOnInteraction);
          document.removeEventListener('touchstart', playOnInteraction);
        };
        document.addEventListener('click', playOnInteraction, { once: true });
        document.addEventListener('touchstart', playOnInteraction, { once: true });
      });
    }
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    const container = containerRef.current;
    
    if (!video || !container) return;

    setupVideo();

    // 비디오 로드 완료 시 즉시 재생 시도
    const handleCanPlay = () => {
      console.log('🎬 ServiceBackground 재생 가능 상태');
      setTimeout(forcePlayVideo, 100);
    };

    const handleLoadedData = () => {
      console.log('✅ ServiceBackground 비디오 로드 완료');
      setTimeout(forcePlayVideo, 200);
    };

    // 교차 관찰자 - 더 적극적으로 설정
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log('🎬 ServiceBackground 섹션 진입 - 비디오 활성화');
            setTimeout(forcePlayVideo, 300);
          }
        });
      },
      {
        root: null,
        rootMargin: '100px', // 더 넓은 여유 공간
        threshold: 0.1
      }
    );

    observer.observe(container);

    // 이벤트 리스너 등록
    video.addEventListener('canplay', handleCanPlay);
    video.addEventListener('loadeddata', handleLoadedData);

    // 초기 재생 시도
    setTimeout(() => {
      if (video.readyState >= 2) {
        forcePlayVideo();
      }
    }, 500);

    return () => {
      observer.disconnect();
      video.removeEventListener('canplay', handleCanPlay);
      video.removeEventListener('loadeddata', handleLoadedData);
    };
  }, [setupVideo, forcePlayVideo]);

  // 에러 처리
  const handleVideoError = useCallback((e) => {
    const error = e.target.error;
    if (error) {
      console.error('❌ ServiceBackground 비디오 에러:', {
        code: error.code,
        message: error.message
      });
      
      // 네트워크 에러인 경우 재시도
      if (error.code === MediaError.MEDIA_ERR_NETWORK) {
        console.log('🔄 네트워크 에러 - 2초 후 재시도');
        setTimeout(() => {
          e.target.load();
        }, 2000);
      }
    }
  }, []);

  return (
    <div 
      ref={containerRef}
      className="h-screen w-full bg-black relative overflow-hidden"
    >
      <video 
        ref={videoRef}
        muted 
        autoPlay 
        loop 
        playsInline 
        preload="auto"
        className="w-full h-full object-cover"
        style={{
          // 하드웨어 가속 최적화
          willChange: 'transform',
          backfaceVisibility: 'hidden',
          perspective: '1000px'
        }}
        onError={handleVideoError}
        onLoadedData={() => console.log('✅ ServiceBackground 데이터 로드')}
        onCanPlay={() => console.log('🎬 ServiceBackground 재생 준비 완료')}
        onPlay={() => console.log('▶️ ServiceBackground 재생 시작')}
        onPause={() => console.log('⏸️ ServiceBackground 일시정지')}
      >
        <source src="/images/main/video1.mp4" type="video/mp4" />
        비디오를 지원하지 않는 브라우저입니다.
      </video>
      

    </div>
  );
};

export default ServiceBackground; 